import React from 'react'
import "./Kyc_and_Bank_details.css"
import Common_recharge_page_banner from '../../common_components/common_banner/common_recharge_page_banner/Common_recharge_page_banner'
import Kyc_tab_content from '../../profile/profile_tabs_and_content/profile_all_contents/kyc_tab_content/Kyc_tab_content'
import Contribution from '../../home/contribution/Contribution'

function Kyc_and_Bank_details() {

    return (
        <>
            <section className='Main_wallet_Withdrowal  '>
                <div className="container">
                    <Common_recharge_page_banner title="KYC & BANK DETAILS" className="Upgraded_menu_banner" />
                    <div className="row justify-content-center">
                        <div className="col-lg-7 col-md-10">
                            <div className="profile_tabs_and_content">
                                <div className="section_holder">
                                    <Kyc_tab_content />
                                </div>
                            </div>

                        </div>
                    </div>

                    <Contribution />
                </div>
            </section>
        </>
    )
}

export default Kyc_and_Bank_details